/* eslint-disable no-undef */
$('.map-container')
  .click(function () {
    $(this).find('iframe').addClass('clicked')
  })
  .mouseleave(function () {
    $(this).find('iframe').removeClass('clicked')
  })

  // videos

$(document).ready(function() {
  var videos = $("video");
  videos.each( function() {
      if( is_mediaelement_video(this) ) {
          return
      }
      var video = $(this).get(0)
      if(video.autoplay) {
          $(this).attr('playsinline', '')
          video.play()
      } else {
          $(this).after('<div class="play-button"><span></span></div>')
          $(this).prop('muted', true)
          $(this).prop('loop', true)
          video.play() 
      }
  })

  var vimeo_videos = $('.vimeo-video-block.controls')
  if(vimeo_videos.length > 0) {
      vimeo_videos.each( function() {
          $(this).append('<div class="play-button"><span></span></div>')
  
          var play_button = $(this).find('.play-button')
  
          var iframe = $(this).find('iframe')[0];
          if(iframe) {
              var player = new Vimeo.Player(iframe);
              player.on('finish', function() {
                  play_button.show()
              });
          }
      })
  }

  $('video').on("ended", function() {
      $(this).siblings('.play-button').show()
      $(this).prop('muted', true)
  });

  //vimeo-video-block
  vimeo_background_videos()
});

$( window ).resize(function() {
  vimeo_background_videos()
});

$(document).on('click', '.play-button', function() {
  if( $(this).parent().hasClass('vimeo-video-block') ) {
      var iframe = $(this).parent().find('iframe')
      if(iframe.length > 0) {
          var iframeUrl = iframe.attr('src');
          var pattern = /(\?|&)muted=1(&|$)/;
          if( pattern.test(iframeUrl)) {
              var newUrl = iframeUrl.replace(pattern, '$1muted=0$2');
              iframe.attr('src', newUrl);
              var player = new Vimeo.Player(iframe);
              player.loadVideo(newUrl);
          } else {
              iframe[0].contentWindow.postMessage(JSON.stringify({
                  'method': 'play'
                }), '*');
          }
          $(this).hide()
      }
  } else {
      var video = $(this).siblings('video')
      if( video.length < 1 ) {
          return
      }
      video.prop('muted', false)
      video.get(0).play()
      $(this).hide()
  }
})

$(document).on( 'click', "video ", function() {
  if( $(this).parents('.vimeo-video-block').length < 1 && !is_mediaelement_video(this) ) {
      var video = $(this).get(0);

      if ( video.paused ) {
          video.play();
          $(this).prop('muted', false)
          $(this).siblings('.play-button').hide()
      } else {
          $(this).prop('muted', true)
          $(this).siblings('.play-button').show()
      }
      return false;
  }
});

$(document).on('click', '.vimeo-video-block.controls', function(e) {
  var clickedElement = e.target;
  var isPlayButton = $(clickedElement).is('.play-button');
  var isPlayButtonChild = $(clickedElement).closest('.play-button').length > 0;

  if( !isPlayButton && !isPlayButtonChild ) { 
      var iframe = $(this).find('iframe')
      var iframeUrl = iframe.attr('src');
      var autoplay = /(\?|&)autoplay=1(&|$)/;
      var muted = /(\?|&)muted=1(&|$)/;
      var loop = /(\?|&)loop=1(&|$)/;
      if( !muted.test(iframeUrl) && autoplay.test(iframeUrl) && loop.test(iframeUrl) ) {
          var pattern = /(\?|&)muted=0(&|$)/;
          var newUrl = iframeUrl.replace(pattern, '$1muted=1$2');
          iframe.attr('src', newUrl);
          var player = new Vimeo.Player(iframe);
          player.loadVideo(newUrl);
          iframe[0].contentWindow.postMessage(JSON.stringify({
              'method': 'pause'
            }), '*');
      } else {
          iframe[0].contentWindow.postMessage(JSON.stringify({
              'method': 'pause'
            }), '*');
      }
      $(this).find('.play-button').show()

  }
})

/* MediaElement moves the video into its own wrapper, so it is no longer a
   sibling of the injected play button, and it has its own controls. */
function is_mediaelement_video(video) {
  return $(video).closest('.wp-playlist, .wp-video, .wp-audio-shortcode, .mejs-container').length > 0
}

//vimeo-video-block
function vimeo_background_videos() {
  $('.vimeo-video-block.background, .vimeo-video-block.square').each( function() {
      var block_ratio = $(this).width() / $(this).height()
      var video_ratio = $(this).attr('ratio')
      if( block_ratio < video_ratio ) {
          $(this).removeClass('height-over')
          $(this).addClass('width-over')
          $(this).find('iframe').show()
      } else {
          $(this).removeClass('width-over')
          $(this).addClass('height-over')
          $(this).find('iframe').show()
      }
  })
}

function play_closest_video(element) {
  var closest_video = ''
  while( closest_video == '' || element.get(0) === document.body ) {
      if( element.parent().find('.vimeo-video-block').length > 0 ) {
          closest_video = element.parent().find('.vimeo-video-block')
      } else {
          element = element.parent()
      }    
  }
  if( closest_video !== '' ) {
      closest_video.find('.play-button').click()
  }
}